import React from 'react';
import { getRouterPath } from 'utils/navigation';
import { Redirect } from 'react-router';
import moment from 'moment-timezone';

import { commonFilterOptions } from 'utils/dateRangeFilterOptions';

export const DATE_FILTER_OPTIONS = [
  commonFilterOptions.PAST_24HOURS,
  commonFilterOptions.PAST_7DAYS,
  commonFilterOptions.PAST_30DAYS,
  commonFilterOptions.PAST_60DAYS,
  commonFilterOptions.PAST_90DAYS,
  commonFilterOptions.DATE_RANGE,
];

const LegacyAlertsRedirect = ({ pathname }) => {
  const deconstructedPathname = pathname.split('/');

  const dateFilterType = DATE_FILTER_OPTIONS.map(dfo => dfo.value).includes(
    deconstructedPathname[4],
  )
    ? deconstructedPathname[4]
    : 'DATE_RANGE';

  const dateRange =
    dateFilterType !== 'DATE_RANGE'
      ? DATE_FILTER_OPTIONS.find(
          dfo => dfo.value === dateFilterType,
        )?.getDateRangeGetter()()
      : { from: deconstructedPathname[4], to: deconstructedPathname[5] };

  const params = [];
  if (deconstructedPathname[4]) {
    params.push(`dateFilterType=${dateFilterType}`);
    if (dateFilterType === 'DATE_RANGE') {
      params.push(`from=${dateRange.from}`);
      params.push(`to=${dateRange.to ?? moment().format()}`);
    }
  }
  if (deconstructedPathname[6] === 'responseOptionsDefined') {
    params.push(`responseOptionsDefined=true`);
  }
  if (deconstructedPathname[7]) {
    params.push(`recipientId=${deconstructedPathname[7]}`);
  }
  if (deconstructedPathname[8]) {
    params.push(`recipientName=${deconstructedPathname[8]}`);
  }
  if (deconstructedPathname[9]) {
    params.push(`recipientType=${deconstructedPathname[9]}`);
  }
  if (deconstructedPathname[10]) {
    params.push(`priority=${deconstructedPathname[10]}`);
  }
  if (deconstructedPathname[11]) {
    params.push(`workflows=${deconstructedPathname[11]}`);
  }

  const updatedPathname = `/alerts?${params.join('&')}`;

  return <Redirect to={getRouterPath(updatedPathname)} />;
};

LegacyAlertsRedirect.displayName = 'LegacyAlertsRedirect';

export default LegacyAlertsRedirect;
